import { render, staticRenderFns } from "./ui-tabs.vue?vue&type=template&id=2f4e0a77&"
import script from "./ui-tabs.vue?vue&type=script&lang=js&"
export * from "./ui-tabs.vue?vue&type=script&lang=js&"
import style0 from "./ui-tabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f4e0a77')) {
      api.createRecord('2f4e0a77', component.options)
    } else {
      api.reload('2f4e0a77', component.options)
    }
    module.hot.accept("./ui-tabs.vue?vue&type=template&id=2f4e0a77&", function () {
      api.rerender('2f4e0a77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-tabs/ui-tabs.vue"
export default component.exports